// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestedProductsCarousel_container__dXHPk"};